import axios from "axios";

const TIMEOUT = 10000;
const URL = process.env.REACT_APP_API_HOST;

export var objIdComparator = function (obj) {
    return obj.id === this;
};

export var addContact = function (payload) {
    var body = new FormData();
    body.append('email', payload.email);
    body.append('name', payload.name);
    body.append('subject', payload.subject);
    body.append('message', payload.message);

    return axios({
        method: "post",
        url: URL,
        data: body,
        timeout: TIMEOUT,
        validateStatus: function (status) {
            return status < 500;
        },
    });
}